import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import bgImg from '../images/bg2.png';
import { ReactComponent as Spinner } from '../images/spinner.svg';

const ApplicationSpinnerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.BLACK};
  background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
`;

function ApplicationSpinner({ t }) {
  return (
    <ApplicationSpinnerContainer>
      <Spinner id="SSO.Spinner" alt={t('Spinner')} />
    </ApplicationSpinnerContainer>
  );
}

ApplicationSpinner.propTypes = {
  t: PropTypes.func.isRequired, // supplied from withTranslation
};

export default withTranslation()(ApplicationSpinner);
